export var VARIABLE_REGEX = /\${(.*?)}+/;
